import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "font-weight"
    }}>{`font-weight`}</h1>
    <p><strong parentName="p">{`Since`}</strong>{` UXP v3.0`}</p>
    <p>{`Sets the font weight for the element. Supports `}<inlineCode parentName="p">{`normal`}</inlineCode>{` (default), `}<inlineCode parentName="p">{`bold`}</inlineCode>{`, `}<inlineCode parentName="p">{`lighter`}</inlineCode>{`, and `}<inlineCode parentName="p">{`bolder`}</inlineCode>{`, as well as the following numeric weights: `}<inlineCode parentName="p">{`50`}</inlineCode>{`, `}<inlineCode parentName="p">{`100`}</inlineCode>{`, `}<inlineCode parentName="p">{`200`}</inlineCode>{`, `}<inlineCode parentName="p">{`300`}</inlineCode>{`, `}<inlineCode parentName="p">{`400`}</inlineCode>{`, `}<inlineCode parentName="p">{`500`}</inlineCode>{`, `}<inlineCode parentName="p">{`550`}</inlineCode>{`, `}<inlineCode parentName="p">{`600`}</inlineCode>{`, `}<inlineCode parentName="p">{`700`}</inlineCode>{`, `}<inlineCode parentName="p">{`800`}</inlineCode>{`, `}<inlineCode parentName="p">{`850`}</inlineCode>{`, `}<inlineCode parentName="p">{`900`}</inlineCode>{`, `}<inlineCode parentName="p">{`950`}</inlineCode>{`, and `}<inlineCode parentName="p">{`1000`}</inlineCode>{`.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en/docs/Web/CSS/font-weight"
      }}>{`https://developer.mozilla.org/en/docs/Web/CSS/font-weight`}</a></p>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-css"
      }}>{`.someElement {
    font-weight: bold;
}
`}</code></pre>
    <h2 {...{
      "id": "quirks-and-exceptions"
    }}>{`Quirks and Exceptions`}</h2>
    <ul>
      <li parentName="ul">{`Text edit fields do not support overriding the font weight.`}</li>
      <li parentName="ul">{`Not all Spectrum UXP components support overriding the font weight.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      